import _sfc_main from "./Logo.vue2.mjs";
/* empty css           */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "logo-container" }, [!_setup.isMobile && _setup.isZH && _setup.isBlackTheme ? _c("div", [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoOfPCInChineseBlackIcon } })], 1) : _vm._e(), !_setup.isMobile && _setup.isZH && _setup.isWhiteTheme ? _c("div", [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoOfPCInChineseWhiteIcon } })], 1) : _vm._e(), _setup.isMobile && _setup.isZH ? _c("div", { staticClass: "mobile-zh-logo" }, [_c("span", { staticClass: "logo", class: _setup.isWhiteTheme ? "white" : "black" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoOfMobileInChinese } })], 1), _c("span", { staticClass: "title" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoTitleOfMobileInChinese } })], 1)]) : _vm._e(), _setup.isEN ? _c("div", { class: ["pc-en-logo", { mobile: _setup.isMobile }] }, [_c("span", { staticClass: "logo" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoInEnglish } })], 1), _c("span", { staticClass: "title", class: _setup.isWhiteTheme ? "white" : "black" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.LogoTitleInEnglish } })], 1)]) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7e1c76c2"
);
const Logo = __component__.exports;
export {
  Logo as default
};
